<template>
  <b-container id="body-container" style="padding: 0px" fluid>
    <b-row class="justify-content-center mb-5">
      <b-col cols="10">

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h4 class="text-blackish title-body">Prove Desire</h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h5>New hires start a new job because they want to make an impact and take on more responsibility</h5>
            </span>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h4 class="text-blackish title-body">Prove Authority </h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <h5>New hires are brought in to make change. No one says no to a new hire. </h5>
            <h5>New hires have budgets to set up the tools and team they need to get the job done.</h5>
          </b-col>
        </b-row>




        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h4 class="text-blackish title-body">Prove Timing</h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h5>New hires have 90 days to make an impact and prove their worth</h5>
              <h5>They buy software for quick wins they can share with management. They rate to set up large initiatives before they are blocked by politics & legacy.</h5>
            </span>
          </b-col>
        </b-row>


      </b-col>
    </b-row>


    <b-row id="launch-today-container" class="justify-content-center live-now">
      <b-col md="10">
        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="12" md="12">
            <span>
              <h2 class="text-blackish cta-title" style="text-align:center; color:white"><span style="color:deepskyblue">New Hires</span> have the <span style="color:deepskyblue">desire</span>, <span style="color:deepskyblue">authority</span>, and <span style="color:deepskyblue">the exact timing</span> to make a purchase </h2>
            </span>
          </b-col>
        </b-row>

        <b-row class="">
        <b-col md="12" cols="12" class="buttons-close" >
          <span
            class="d-flex justify-content-center"
          >
            <b-button
                class="free-trial-button"
                @click.prevent="scrollFix('#filters')"
              >Request Demo</b-button>
          </span>

          <!--
          <a
            href="https://www.launchgravity.com/masters-of-marketing/#upcoming"
          >
            <b-button class="button-white-transparen"><b>Check our events</b></b-button>
          </a>
          -->
        </b-col>
      </b-row>
      </b-col>
    </b-row>

   <b-row class="justify-content-center mb-5">
    <b-col cols="12" id="filters">

      <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="12" md="12">
            <div class=" mx-auto">
              <div class="calendly-inline-widget" data-url="https://calendly.com/rosse/track-new-hires?text_color=193b56&primary_color=1765d8"></div>
            </div>
          </b-col>
        </b-row>
    </b-col>
   </b-row>

  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/screens/masters-of-marketing/body.sass
@import @/sass/_components/main-card.sass
@import @/sass/screens/home/header.sass

</style>

<script>
// components
// import MainCard from '@/components/mainCardHome'
// import ourFleet from '@/components/ourFleetCard'
// import ourFleetOG from '@/components/ourFleetCardOriginal'
// import HostCard from '@/components/hostCard'
import VueScrollTo from 'vue-scrollto';

// data
// import { guests, yourHosts } from '@/data/masters-of-marketing.js'

export default {
  name: 'Body',
  components: {
    //MainCard,
    // ourFleet,
    //ourFleetOG,
    // HostCard
  },
  data: function() {
    return {
      timer: null,
      currentDate: null,

    }
  },
  computed: {
  },
  mounted() {
    let externalScript = document.createElement('script')
    externalScript.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js')
    document.head.appendChild(externalScript)
  },
  created() {
  },
  methods: {
    scrollFix: function(hash) {
      console.log('Scroll To')
      VueScrollTo.scrollTo(hash, 3000)
    },

  },
}
</script>
